<template shrink>
  <w-toolbar shadow>
    <a href="https://misis.club/tos.txt" class="title3" style="color:black;">
      Пользовательское соглашение
    </a>
    <div class="spacer"></div>
    <a href="https://t.me/misis_club">
      <font-awesome-icon :icon="['fab', 'telegram']" size="lg" color="black"/>

    </a>
  </w-toolbar>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style>
a:link { color: black; }
</style>
